<script setup lang="ts">
import type { NuxtError } from '#app'

const runtimeConfig = useRuntimeConfig()
useHead({
	meta: [{ name: 'version', content: runtimeConfig.public.clientVersion }],
})

const props = defineProps<{ error: NuxtError }>()

const data = typeof props.error?.data === 'string' ? JSON.parse(props.error.data) : {}
</script>

<template>
	<NuxtLayout>
		<div class="flex flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
			<div class="flex flex-col items-center justify-center">
				<h1 class="text-3xl font-bold text-center text-gray-900">Error {{ props.error.statusCode }}</h1>
				<p class="text-center text-gray-600">{{ props.error.statusMessage }}</p>

				<div v-if="data.link" class="mt-4">
					<NuxtLink :to="data.link" class="btn-primary">Go back</NuxtLink>
				</div>
			</div>
		</div>
	</NuxtLayout>
</template>
